import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createEventPool(_, eventPool) {
    const response = await axios.post('/blade/event-pools', eventPool);
    return response.data.eventPool;
  },
  async getEventPools() {
    const response = await axios.get('/blade/event-pools');
    return response.data.eventPools;
  },
  async getEventPool(_, { eventPoolId }) {
    const { data } = await axios.get(`/blade/event-pools/${eventPoolId}`);
    return data;
  },
  async getEventPoolTypes({ dispatch }) {
    return dispatch('getEventPool', { eventPoolId: 'types' });
  },
  async updateEventPool(_, eventPool) {
    const response = await axios.patch(`/blade/event-pools/${eventPool._id}`, eventPool);
    return response.data.eventPool;
  },
  async syncEventPoolWithGoogleSheet(_, eventPool) {
    const response = await axios.patch(
      `/blade/event-pools/${eventPool._id}/sheetsync/${eventPool.lastSyncedSheetId}`,
      { section: eventPool.lastSyncedSection, origin: window.origin },
    );
    return response.data.eventPool;
  },
  async deleteEventPool(_, { eventPoolId, _id }) {
    const did = eventPoolId || _id;
    const response = await axios.delete(`/blade/event-pools/${did}`);
    return response.data.eventPool;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/event-pools.js